import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('../views/market/Market.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product/Product.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/trading',
    name: 'trading',
    component: () => import('../views/trading/Trading.vue')
  },
  {
    path: '/newtrading',
    name: 'newtrading',
    component: () => import('../views/newtrading/NewTrading.vue')
  },
  {
    path: '/newtrading/detail',
    name: 'newtrading-detail',
    component: () => import('../views/newtrading/components/newtrading_detail_h5.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/newtrading/records',
    name: 'newtrading-records',
    component: () => import('../views/newtrading/components/newtrading_records_h5.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('../views/orders/Orders.vue')
  },
  {
    path: '/loan',
    name: 'loan',
    component: () => import('../views/loan/Loan.vue')
  },
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import('../views/transfer/Transfer.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/nfts',
    name: 'nfts',
    component: () => import('../views/nfts/Nfts.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/cruuency',
    name: 'cruuency',
    component: () => import('../views/cruuency/Cruuency.vue')
  },
  {
    path: '/profile/balance',
    name: 'balance',
    component: () => import('../views/profile/balance/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/wallet',
    name: 'wallet',
    component: () => import('../views/profile/wallet/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/deposit',
    name: 'deposit',
    component: () => import('../views/profile/deposit/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/withdraw',
    name: 'withdraw',
    component: () => import('../views/profile/withdraw/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/balancebb',
    name: 'balancebb',
    component: () => import('../views/profile/balancebb/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/kefu',
    name: 'kefu',
    component: () => import('../views/profile/kefu/index.vue'),
    meta: { hideTabBar: true, requiresAuth: false }  // 改为false，客服页面不需要登录
  },
  {
    path: '/profile/qiandao',
    name: 'qiandao',
    component: () => import('../views/profile/qiandao/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/invite',
    name: 'invite',
    component: () => import('../views/profile/invite/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/language',
    name: 'language',
    component: () => import('../views/language/Language.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/profile/notification',
    name: 'notification',
    component: () => import('../views/profile/notification/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/kyc',
    name: 'kyc',
    component: () => import('../views/profile/kyc/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/profile/password',
    name: 'password',
    component: () => import('../views/profile/password/index.vue'),
    meta: { hideTabBar: true, requiresAuth: true }
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help/index.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/help/faq',
    name: 'faq',
    component: () => import('../views/help/faq/index.vue'),
    meta: { hideTabBar: true }
  },
  {
    path: '/pass/register',
    name: 'register',
    component: () => import('../views/pass/register/index.vue')
  },
  {
    path: '/pass/login',
    name: 'login',
    component: () => import('../views/pass/login/index.vue')
  },
  {
    path: '/pass/reset',
    name: 'reset',
    component: () => import('../views/pass/reset/index.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail/index.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/Introduction/index.vue')
  },
  {
    path: '/help/notice',
    name: 'notice',
    component: () => import('../views/help/notice/index.vue')
  },
  {
    path: '/api/loginCallback/google',
    name: 'google',
    component: () => import('../views/api/loginCallback/google.vue')
  },
  // 重定向
  {
    path: '*',
    redirect: '/'
  }

]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Navigation guard to prevent duplicate navigation errors
router.beforeEach((to, from, next) => {
  //console.log('🛣️ 路由导航:', { from: from.path, to: to.path, fromName: from.name, toName: to.name });

  // 检查是否需要登录验证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查登录状态
    const token = localStorage.getItem('token');
    const isLogin = localStorage.getItem('isLogin');
    const isLoggedIn = !!(token || isLogin === 'true' || isLogin === '1');
    
    if (!isLoggedIn) {
      //console.log('🔒 未登录，重定向到登录页');
      next({
        path: '/pass/login',
        query: { redirect: to.fullPath } // 保存目标路径，登录后可以跳转回去
      });
      return;
    }
  }

  // ✅ 检测是否为移动设备（只根据 User Agent 判断，不考虑窗口大小）
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
  const isMobile = mobileRegex.test(userAgent);
  const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
  const isPcByUserAgent = !(isMobile && !isTablet); // User Agent 判断是否为 PC
  
  // ✅ 只根据设备类型（User Agent）判断，不考虑窗口宽度
  // 这样PC端缩小窗口也不会切换到移动端模式
  const isPc = isPcByUserAgent;
  const isH5 = !isPc; // 非PC即为移动端
  
  // 注释掉原来的窗口宽度检查逻辑
  // const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  // const isPcByWidth = windowWidth > 768;
  // const isPc = isPcByUserAgent && isPcByWidth;

  // PC端路由限制：只允许访问首页（/）
  if (isPc && to.path !== '/') {
    //console.log('💻 PC端访问非首页路径 → 强制跳转到首页');
    next('/');
    return;
  }

  // H5模式下，访问根路径时直接重定向到 /market
  if ((to.path === '/' || to.path === '/home') && isH5) {
    //console.log('📱 移动设备访问根目录 → 直接跳转到 /market');
    next('/market');
    return;
  }

  // 只有在非初始导航且路径相同时才阻止
  // 页面刷新时 from.name 为 null，此时应该允许导航
  if (from.name && to.path === from.path && to.name === from.name) {
    // //console.log('⚠️ 阻止重复导航');
    next(false);
    return;
  }

  // //console.log('✅ 允许路由导航');
  next();
});

// 监听路由变化
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

// let whiteList = ['login', 'register', 'reset']

export default router
